// import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
// import { useState } from "react";

// const containerStyle = {
//   width: "100%",
//   height: "500px",
// };

// const defaultCenter = {
//   lat: 20.5937, // India center
//   lng: 78.9629,
// };

// export default function GoogleMapModal({ onClose, onSelect }) {
//   const { isLoaded } = useJsApiLoader({
//     googleMapsApiKey: "AIzaSyBUAOeedBBdZ8EaW1el4Cq7bEURP4LjgEc",
//   });

//   const [marker, setMarker] = useState(null);

//   const handleMapClick = (e) => {
//     const lat = e.latLng.lat();
//     const lng = e.latLng.lng();

//     setMarker({ lat, lng });
//   };

//   if (!isLoaded) return <div>Loading Map...</div>;

//   return (
//     <div
//       style={{
//         position: "fixed",
//         top: 0,
//         left: 0,
//         width: "100vw",
//         height: "100vh",
//         background: "rgba(0,0,0,0.5)",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         zIndex: 9999,
//       }}
//     >
//       <div
//         style={{
//           width: "80%",
//           background: "#fff",
//           padding: "20px",
//           borderRadius: "10px",
//         }}
//       >
//         <GoogleMap
//           mapContainerStyle={containerStyle}
//           center={defaultCenter}
//           zoom={5}
//           onClick={handleMapClick}
//         >
//           {marker && <Marker position={marker} />}
//         </GoogleMap>

//         <div style={{ marginTop: "15px", textAlign: "right" }}>
//           <button onClick={onClose} style={{ marginRight: "10px" }}>
//             Cancel
//           </button>

//           {marker && (
//             <button
//               onClick={() => {
//                 onSelect(marker); // 🔥 send lat/lng to parent
//                 onClose();
//               }}
//             >
//               Confirm Location
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }



import { GoogleMap, useJsApiLoader, Marker, DrawingManager, Polygon, Circle } from "@react-google-maps/api";
import { useState, useRef, useCallback, useEffect } from "react";
import "../Style/Component/GoogleMapModal.css";

const containerStyle = {
  width: "100%",
  height: "380px",
};

const defaultCenter = {
  lat: 20.5937,
  lng: 78.9629,
};

export default function GoogleMapModal({ onClose, onSelect, initialData }) {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyBUAOeedBBdZ8EaW1el4Cq7bEURP4LjgEc",
    libraries: ["places", "drawing"],
  });

  const [marker, setMarker] = useState(null);
  const [polygonPath, setPolygonPath] = useState([]);
  const [circleData, setCircleData] = useState(null);
  const [districtSearch, setDistrictSearch] = useState("");
  const [citySearch, setCitySearch] = useState("");
  const [map, setMap] = useState(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [isPinning, setIsPinning] = useState(false);
  const [isPencilDown, setIsPencilDown] = useState(false);
  const tempPathRef = useRef([]);

  // 🔥 Handle Initial Data for Editing
  useEffect(() => {
    if (initialData && isLoaded) {
      setCitySearch(Array.isArray(initialData.city) ? initialData.city[0] : initialData.city || "");
      setDistrictSearch(initialData.district || "");

      const lat = Number(initialData.lat);
      const lng = Number(initialData.long);

      if (!isNaN(lat) && !isNaN(lng)) {
        setMarker({ lat, lng });
        if (map) {
          map.panTo({ lat, lng });
          map.setZoom(12);
        }
      }

      // Transform GeoJSON coordinates [[lng, lat]] to [{lat, lng}]
      if (initialData.zone && initialData.zone.coordinates && initialData.zone.coordinates[0]) {
        const transformedPath = initialData.zone.coordinates[0].map(coord => ({
          lat: coord[1],
          lng: coord[0]
        }));
        // Remove duplicate last point if it's a closed GeoJSON polygon
        if (transformedPath.length > 1 &&
          transformedPath[0].lat === transformedPath[transformedPath.length - 1].lat &&
          transformedPath[0].lng === transformedPath[transformedPath.length - 1].lng) {
          transformedPath.pop();
        }
        setPolygonPath(transformedPath);
      }
    }
  }, [initialData, isLoaded, map]);

  const handleMouseDown = useCallback((e) => {
    if (!isDrawing || !map) return;
    map.setOptions({ draggable: false, scrollwheel: false });
    setIsPencilDown(true);
    tempPathRef.current = [e.latLng];
    setPolygonPath([e.latLng.toJSON()]);
  }, [isDrawing, map]);

  const handleMouseMove = useCallback((e) => {
    if (!isDrawing || !isPencilDown || !map) return;
    tempPathRef.current.push(e.latLng);
    setPolygonPath(tempPathRef.current.map(p => p.toJSON()));
  }, [isDrawing, isPencilDown, map]);

  const handleMouseUp = useCallback(() => {
    if (!isDrawing || !isPencilDown || !map) return;
    map.setOptions({ draggable: true, scrollwheel: true });
    setIsPencilDown(false);
    setIsDrawing(false);

    if (tempPathRef.current.length > 2) {
      const bounds = new window.google.maps.LatLngBounds();
      tempPathRef.current.forEach(p => bounds.extend(p));
      const center = bounds.getCenter();
      const latLng = { lat: center.lat(), lng: center.lng() };
      setMarker(latLng);

      // 🔥 Auto-fill search boxes after drawing
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: latLng }, (results, status) => {
        if (status === "OK" && results[0]) {
          const components = results[0].address_components;
          components.forEach(c => {
            if (c.types.includes("locality") || c.types.includes("administrative_area_level_2")) {
              setCitySearch(c.long_name);
            }
            if (c.types.includes("administrative_area_level_3")) {
              setDistrictSearch(c.long_name);
            }
          });
        }
      });
    }
  }, [isDrawing, isPencilDown, map]);

  const handleMapClick = useCallback((e) => {
    const latLng = e.latLng.toJSON();

    if (isPinning) {
      // 🔥 Multi-point pinning: Add to the list
      setPolygonPath(prev => [...prev, latLng]);
      setMarker(latLng);
    } else if (!isDrawing) {
      // Simple single click
      setMarker(latLng);
      setPolygonPath([]);
      setCircleData(null);
    }

    // 🔥 Auto-fill search boxes
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === "OK" && results[0]) {
        const components = results[0].address_components;
        components.forEach(c => {
          if (c.types.includes("locality") || c.types.includes("administrative_area_level_2")) {
            setCitySearch(c.long_name);
          }
          if (c.types.includes("administrative_area_level_3")) {
            setDistrictSearch(c.long_name);
          }
        });
      }
    });
  }, [isDrawing, isPinning]);

  const clearMap = () => {
    setMarker(null);
    setPolygonPath([]);
    setCircleData(null);
    setIsDrawing(false);
    tempPathRef.current = [];
  };

  const handleDistrictSearch = () => {
    if (!districtSearch.trim() || !map) return;
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address: districtSearch }, (results, status) => {
      if (status === "OK" && results[0]) {
        const location = results[0].geometry.location;
        const lat = location.lat();
        const lng = location.lng();
        setMarker({ lat, lng });
        map.panTo({ lat, lng });
        map.setZoom(12);

        // 🔥 Try to find City from District search
        const components = results[0].address_components;
        components.forEach(c => {
          if (c.types.includes("locality") || c.types.includes("administrative_area_level_2")) {
            setCitySearch(c.long_name);
          }
        });
      }
    });
  };

  const handleCitySearch = () => {
    if (!citySearch.trim() || !map) return;
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address: citySearch }, (results, status) => {
      if (status === "OK" && results[0]) {
        const location = results[0].geometry.location;
        const lat = location.lat();
        const lng = location.lng();
        setMarker({ lat, lng });
        map.panTo({ lat, lng });
        map.setZoom(14);
      }
    });
  };

  const handleConfirm = () => {
    if (marker) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: marker }, (results, status) => {
        if (status === "OK" && results[0]) {
          const addressComponents = results[0].address_components;
          let foundCity = "";
          let foundDistrict = "";

          addressComponents.forEach((component) => {
            // Robust check for City
            if (component.types.includes("locality") || component.types.includes("postal_town") || component.types.includes("administrative_area_level_2")) {
              foundCity = component.long_name;
            }
            // Robust check for District
            if (component.types.includes("administrative_area_level_3") || component.types.includes("sublocality")) {
              foundDistrict = component.long_name;
            }
          });

          // Use searched names if manual edit exists, otherwise use found names
          const finalCity = citySearch || foundCity;
          const finalDistrict = districtSearch || foundDistrict;

          // Transform [{lat, lng}] to [[lng, lat]] for GeoJSON
          const geoJsonCoords = polygonPath.map(p => [p.lng, p.lat]);
          // Close polygon for GeoJSON
          if (geoJsonCoords.length > 0) {
            geoJsonCoords.push([geoJsonCoords[0][0], geoJsonCoords[0][1]]);
          }

          const payload = {
            ...(initialData || { vehicle: ["Car", "Auto", "Bike"], status: "Active" }),
            city: finalCity,
            district: finalDistrict,
            lat: marker.lat,
            long: marker.lng,
            zone: {
              type: "Polygon",
              coordinates: geoJsonCoords.length > 0 ? [geoJsonCoords] : []
            },
            radius: circleData ? circleData.radius : null,
          };

          onSelect(payload);
          onClose();
        } else {
          // If geocoding fails but search boxes have text, use those
          const geoJsonCoords = polygonPath.map(p => [p.lng, p.lat]);
          if (geoJsonCoords.length > 0) {
            geoJsonCoords.push([geoJsonCoords[0][0], geoJsonCoords[0][1]]);
          }

          const payload = {
            ...(initialData || { vehicle: ["Car", "Auto", "Bike"], status: "Active" }),
            city: citySearch,
            district: districtSearch,
            lat: marker.lat,
            long: marker.lng,
            zone: {
              type: "Polygon",
              coordinates: geoJsonCoords.length > 0 ? [geoJsonCoords] : []
            },
            radius: circleData ? circleData.radius : null,
          };
          onSelect(payload);
          onClose();
        }
      });
    }
  };

  const isConfirmEnabled = marker || polygonPath.length > 0 || circleData;

  if (!isLoaded) return <div className="loading-map">Loading Map...</div>;

  return (
    <div className="map-modal-overlay">
      <div className="map-modal-container">
        <div className="map-modal-header">
          <h3>Pencil Draw - Drag to Draw Zone</h3>
          <button className="map-modal-close" onClick={onClose}>×</button>
        </div>

        <div className="map-modal-content">
          <div className="search-container">
            <div className="search-inputs-row">
              <div className="search-input-wrapper green-bg">
                <input
                  type="text"
                  placeholder="1. Search District"
                  value={districtSearch}
                  onChange={(e) => setDistrictSearch(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleDistrictSearch()}
                  className="search-input white-text"
                />
              </div>

              <div className="search-input-wrapper green-bg">
                <input
                  type="text"
                  placeholder="2. Search City"
                  value={citySearch}
                  onChange={(e) => setCitySearch(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleCitySearch()}
                  className="search-input white-text"
                />
              </div>

              <button
                className={`draw-action-btn ${isPinning ? 'active' : ''} ${!marker && districtSearch === '' ? 'disabled' : ''}`}
                onClick={() => {
                  setIsPinning(!isPinning);
                  setIsDrawing(false);
                }}
                disabled={!marker && districtSearch === ''}
              >
                {isPinning ? "Click Map to Pin" : "Pin Zone Points"}
              </button>

              <button className="clear-map-btn" onClick={clearMap}>
                Clear
              </button>
            </div>
          </div>

          <div className="draw-tip">
            {isPinning ?
              "Pinning Mode: Click the map multiple times to define your area corners!" :
              "Tip: Click to set a point, or use 'Pin Zone Points' to build a complex area."
            }
          </div>

          <div className="map-wrapper">
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={defaultCenter}
              zoom={5}
              onClick={handleMapClick}
              onMouseDown={handleMouseDown}
              onMouseMove={handleMouseMove}
              onMouseUp={handleMouseUp}
              onLoad={setMap}
              options={{
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                zoomControl: true,
                draggable: !isDrawing,
              }}
            >
              {/* Show All Pinned Points - Modern Pin Icon */}
              {polygonPath.map((p, i) => (
                <Marker 
                  key={i} 
                  position={p} 
                  onClick={() => {
                    // 🔥 Remove pin on click (Unpin)
                    setPolygonPath(prev => prev.filter((_, index) => index !== i));
                  }}
                  icon={{
                    path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
                    fillColor: "#39FF14",
                    fillOpacity: 1,
                    strokeColor: "#013A28",
                    strokeWeight: 1.5,
                    scale: 1.5,
                    anchor: isLoaded && window.google ? new window.google.maps.Point(12, 22) : null,
                  }}
                />
              ))}

              {/* Show Single Marker if no pins */}
              {marker && polygonPath.length === 0 && (
                <Marker
                  position={marker}
                  icon={{
                    path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
                    fillColor: "#013A28",
                    fillOpacity: 1,
                    strokeColor: "#39FF14",
                    strokeWeight: 1.5,
                    scale: 1.8,
                    anchor: isLoaded && window.google ? new window.google.maps.Point(12, 22) : null,
                  }}
                />
              )}

              {polygonPath.length > 0 && (
                <Polygon
                  paths={polygonPath}
                  options={{
                    fillColor: "#39FF14",
                    fillOpacity: 0.25,
                    strokeWeight: 3,
                    strokeColor: "#013A28",
                    clickable: false,
                  }}
                />
              )}

              {circleData && (
                <Circle
                  center={circleData.center}
                  radius={circleData.radius}
                  options={{
                    fillColor: "#39FF14",
                    fillOpacity: 0.4,
                    strokeWeight: 3,
                    strokeColor: "#39FF14",
                  }}
                />
              )}
            </GoogleMap>
          </div>

          <div className="modal-footer">
            <div className="footer-left">
              <span className="question-text">Step 4: Confirm Selection</span>
              <span className="warning-text">Sending all pinned coordinates (Full Lat/Long List)</span>
            </div>
            <div className="footer-right">
              <button
                className={`footer-btn confirm ${!isConfirmEnabled ? 'disabled' : ''}`}
                onClick={handleConfirm}
                disabled={!isConfirmEnabled}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
